import React from 'react';
import MUIBreadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import './style.css';

interface BreadcrumbProps {
    links: string[];
    href?: string[];
    onNavigate?: (path: string) => void;
}

export default function Breadcrumb({ links, href, onNavigate }: BreadcrumbProps) {
    const handleNavigation = (path: string) => {
        if (onNavigate && path && path.trim().length > 0) {
            onNavigate(path);
        }
    };

    return (
        <div className="container-breadcrumb" role="presentation">
            <MUIBreadcrumbs aria-label="breadcrumb">
                {links.map((link, index) => (
                    <Link
                        key={index}
                        underline="hover"
                        color="inherit"
                        onClick={() => {
                            if (href && href[index]) {
                                handleNavigation(href[index]);
                            }
                        }}
                        style={{ cursor: href && href[index] ? 'pointer' : 'default' }}
                    >
                        {link}
                    </Link>
                ))}
            </MUIBreadcrumbs>
        </div>
    );
}